import {StudentActiveContainer} from "./StudentActiveContainer"

export const CourseViewStyles = {
    StudentActiveContainer: StudentActiveContainer
}